import { isUndefined as lo_isUndefined } from 'es-toolkit';

export interface UseIsLoadingOptions {}
export function useIsLoading(options: Partial<UseIsLoadingOptions> = {}) {
    const tracked: Set<string> = reactive(new Set());
    const isLoading = computed<boolean>(() => tracked.size > 0);

    function on(key: string): void {
        tracked.add(key);
    }

    function off(key: string): void {
        tracked.delete(key);
    }

    function toggle(key: string, state?: boolean): void {
        lo_isUndefined(state) ?
            tracked[ tracked.has(key) ? 'delete' : 'add' ](key) :
            tracked[ state ? 'add' : 'delete' ](key);
    }

    function clear(): void {
        tracked.clear();
    }

    return {
        isLoading,
        on,
        off,
        toggle,
        clear,
        tracked: readonly(tracked)
    };
}
